var React = require('react');

function CloseIcon (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_0_2966)","key":0},[React.createElement("path",{"d":"M0.796875 0.125L15.249 14.5771","stroke":"var(--color-gray-grau)","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M15.249 0.125L0.796875 14.5771","stroke":"var(--color-gray-grau)","strokeWidth":"2","key":1})]),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_0_2966"},React.createElement("rect",{"width":"14.4521","height":"14.4521","fill":"white","transform":"translate(0.796875 0.125)"})))]);
}

CloseIcon.defaultProps = {"width":"16","height":"15","viewBox":"0 0 16 15","fill":"none"};

module.exports = CloseIcon;

CloseIcon.default = CloseIcon;
